import { Menu } from '@mui/icons-material';
import { AppBar, Box, IconButton, Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { uiActions } from '@/store';

import { RegionSwitch } from '../RegionSwitch';
import {
  NavbarActions,
  NavbarLogo,
  NavItems,
  RegionBanner,
  RemainingUsage,
  SearchBar,
} from './components';

const SHADOW_OPACITY_ZONE = 200;

export const AppHeader = () => {
  const dispatch = useDispatch();
  const toggleSidebarDrawer = () => {
    dispatch(uiActions.toggleSidebarDrawer());
  };

  const [shadowOpacity, setShadowOpacity] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const newShadowOpacity = Math.min(
        1,
        window.scrollY / SHADOW_OPACITY_ZONE,
      );
      if (shadowOpacity !== newShadowOpacity)
        setShadowOpacity(newShadowOpacity);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [shadowOpacity]);

  return (
    <AppBar position="fixed" sx={styles.appbar} color="transparent">
      <Box
        sx={[
          styles.header,
          {
            backgroundColor: 'primary.main',
          },
        ]}>
        <IconButton
          sx={{
            color: 'header.icon',
            display: { lg: 'none' },
            mr: {
              xs: 0.5,
              sm: 2,
            },
          }}
          aria-label="Toggle menu"
          onClick={toggleSidebarDrawer}>
          <Menu />
        </IconButton>
        <NavbarLogo />
        <NavItems />
        <Box sx={[styles.rightContainer]}>
          <SearchBar />
          <RegionSwitch />
          <NavbarActions />
        </Box>
        <Box sx={[styles.headerShadow, { opacity: shadowOpacity }]} />
      </Box>
      <RegionBanner />
      <RemainingUsage />
    </AppBar>
  );
};

const styles = {
  appbar: {
    boxShadow: 'none',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    px: { xs: 1, sm: 2, lg: 3 },
    height: ({ dimensions }: Theme) => dimensions.header.height,
    justifyContent: 'space-between',
  },
  headerShadow: {
    position: 'absolute',
    bottom: 0,
    boxShadow: ({ customShadows }: Theme) => customShadows.header,
    width: '100%',
    height: 4,
    zIndex: -1,
    transition: 'opacity 0.3s ease',
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ml: 'auto',
    gap: 1,
  },
};
